import { View } from "react-native";
import { Text } from "@shared/components/text";
import Icon from "@shared/components/md-design-system/Icon/Icon";
import { LockIcon } from "@shared/components/md-design-system/Icon/ActivityIcon";
import { colorPalette } from "@shared/config/colorsConfig";
import { dynamicTranslations } from "@shared/utils/dynamicTranslation";
import { ActivityCtaButton } from "../ActivityCard/ActivityCtaButton";

export interface IReminderCardProps {
    time: string;
    title: string;
    detail: string;
    detailIcon?: string;
    note?: string;
    actionLabel: string;
    actionEnabled?: boolean;
    onPress?: () => void;
}

export const ReminderCard = ({ time, title, detail, detailIcon, note, actionLabel, actionEnabled = false, onPress }: IReminderCardProps) => {
    const { t } = dynamicTranslations();

    return (
        <View className="flex-row items-center border border-gray-300 bg-white gap-4 p-4 rounded-2xl">
            <View className="items-center justify-center w-[84px] rounded-[13px] bg-secondary-800 pt-2 pb-2.5 px-1.5 shrink-0">
                <Text className="text-white font-semibold text-sm tracking-[1.2px]" numberOfLines={1}>
                    {t('screens.activities.reminders.today')}
                </Text>
                <Text className="text-white font-heading text-lg mt-px" numberOfLines={1}>{time}</Text>
            </View>

            <View className="flex-1">
                <Text className="font-bold text-base" numberOfLines={2}>{title}</Text>
                <View className="flex-row items-center gap-[7px] mt-1.5">
                    {!!detailIcon && <Icon name={detailIcon as any} size={18} color={colorPalette.gray[500]} />}
                    <Text className="text-md text-gray-500">{detail}</Text>
                </View>
                {!!note && (
                    <View className="flex-row items-center gap-[7px] mt-[7px]">
                        <LockIcon size={17} color={colorPalette.gray[500]} />
                        <Text className="text-md font-semibold text-gray-500">{note}</Text>
                    </View>
                )}
            </View>

            <ActivityCtaButton
                variant="secondary"
                icon={actionEnabled ? 'unlock' : 'lock'}
                disabled={!actionEnabled}
                onPress={onPress}
            >
                {actionLabel}
            </ActivityCtaButton>
        </View>
    );
};

export default ReminderCard;
